import { Grid, makeStyles, TextField } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import companyEndpoints from 'app/api/services/companyEndpoints';
import StickMessage from 'app/components/StickMessage';
import { SERVICES_CODES } from 'app/config/services';
import { Field } from 'formik';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import styles from './styles';
const useStyles = makeStyles(styles);

const DateInformation = props => {
  const classes = useStyles();

  const { finalDate, setFinalDate } = props;

  const deadLine = useSelector(state => state.revisions.deadLine);
  const actualRevision = useSelector(state => state.revisions.details);
  const request = useSelector(state => state.requests.details);

  const requestJsonData = useMemo(() => {
    return request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};
  }, [request]);

  const initialDate = useMemo(() => {
    return actualRevision.dtCadastro ? new Date(actualRevision.dtCadastro) : new Date();
  }, [actualRevision.dtCadastro]);

  const [company, setCompany] = useState({});
  const [hasFinancialPendencies, setShowStickMessagePendencies] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [days, setDays] = useState(deadLine);

  const [showFinancialPendencies, setShowFinancialPendencies] = useState(() => {
    if (
      request.cdServico === SERVICES_CODES.ACESSO_PORTAL_FISICA ||
      request.cdServico === SERVICES_CODES.ACESSO_PORTAL_JURIDICA
    ) {
      return false;
    }
    return true;
  });

  const dateDiff = (initDate, endDate) => {
    const duration = moment.duration(moment.utc(endDate).diff(moment.utc(initDate)));
    const days = Math.ceil(duration.asDays());
    setDays(days);
  };

  const onChangeDate = value => {
    setFinalDate(value);
    dateDiff(initialDate, value);
  };

  const onClickPendencias = async () => {
    setLoadingPdf(true);
    if (company && Object.keys(company).length > 0) {
      const search = {};
      if (
        (company.deCnpjMatriz && company.deCnpjMatriz !== '') ||
        (company.deCpfCnpj && company.deCpfCnpj !== '')
      ) {
        search.deCnpjMatriz = company.deCnpjMatriz || company.deCpfCnpj;
        search.deRazaoSocial = company.deRazaoSocial || company.nmCompleto;
      }
      if (Object.keys(search).length > 0) {
        const debitResponse = await companyEndpoints.getCompanyDebitCertificates(search);
        if (debitResponse && debitResponse.status === 200) {
          const file = new Blob([debitResponse.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
      }
    }
    setLoadingPdf(false);
  };

  useEffect(() => {
    setDays(deadLine);
    if (actualRevision.dtVencimentoRevisao)
      setFinalDate(moment.utc(actualRevision.dtVencimentoRevisao));
    else {
      setFinalDate(moment.utc(initialDate).add(deadLine, 'days'));
    }
    if (actualRevision.dtCadastro) {
      const duration = moment.duration(
        moment.utc(actualRevision.dtVencimentoRevisao).diff(moment.utc(actualRevision.dtCadastro))
      );
      const days = Math.ceil(duration.asDays());
      setDays(days);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualRevision, deadLine, initialDate]);

  useEffect(() => {
    const init = async () => {
      if (request.cdEmpresa) {
        const response = await companyEndpoints.getCompany({ cdEmpresa: request.cdEmpresa });
        if (response?.status === 200 && response?.data) {
          setCompany(response.data);
        }
      } else if (
        requestJsonData &&
        Object.keys(requestJsonData).length > 0 &&
        request.cdServico !== SERVICES_CODES.ACESSO_PORTAL_FISICA &&
        request.cdServico !== SERVICES_CODES.ACESSO_PORTAL_JURIDICA
      ) {
        setCompany(requestJsonData);
      } else {
        setShowFinancialPendencies(false);
      }
    };
    init();
  }, [request, requestJsonData]);

  useEffect(() => {
    const init = async () => {
      if (company) {
        const seach = {};
        if (company.deCnpjMatriz && company.deCnpjMatriz !== '') {
          seach.deCnpjMatriz = company.deCnpjMatriz;
        } else if (company.deCpfCnpj && company.deCpfCnpj !== '') {
          seach.deCnpjMatriz = company.deCpfCnpj;
        }
        if (Object.keys(seach).length > 0) {
          const response = await companyEndpoints.getCompanyFinancialPendencies(seach);
          if (response?.status === 200) {
            setShowStickMessagePendencies(response.data);
            setShowFinancialPendencies(true);
          }
        } else {
          setShowFinancialPendencies(false);
        }
      }
    };
    init();
  }, [company]);

  return (
    <Grid container spacing={3} className={classes.containerDays}>
      <Grid item xs={12} sm={6} md={showFinancialPendencies ? 3 : 4}>
        <Field
          name="dtCadastro"
          label="Data abertura"
          disableToolbar
          format="DD/MM/YYYY"
          margin="dense"
          invalidLabel="Data inválida"
          invalidDateMessage="Data inválida"
          maxDateMessage="Data inválida"
          minDateMessage="Data inválida"
          disabled
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          as={KeyboardDatePicker}
          value={initialDate}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={showFinancialPendencies ? 3 : 4}>
        <Field
          name="dtVencimentoRevisao"
          label="Data Limite*"
          disableToolbar
          format="DD/MM/YYYY"
          margin="dense"
          invalidLabel="Data inválida"
          invalidDateMessage="Data inválida"
          maxDateMessage="Data inválida"
          minDateMessage="Data inválida"
          onChange={onChangeDate}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          as={KeyboardDatePicker}
          value={finalDate}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={showFinancialPendencies ? 3 : 4}>
        <Field
          name="nuDiasContados"
          label="Dias contados"
          disabled={true}
          margin="dense"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          as={TextField}
          value={days}
        />
      </Grid>
      {showFinancialPendencies && (
        <Grid item xs={12} sm={6} md={3}>
          <StickMessage
            type={'alert'}
            title={
              hasFinancialPendencies
                ? 'Existem pendências financeiras'
                : 'Não existem pendências financeiras'
            }
            hasButton={true}
            loading={loadingPdf}
            onClick={onClickPendencias}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DateInformation;
